import { Controller } from "@hotwired/stimulus"

// シンプルな inline 編集トグル。 display ↔ form を切り替えて、 fetch で非同期保存する
// ( 架電モーダルが閉じないようにページ遷移は起こさない )。
export default class extends Controller {
  static targets = ["display", "form", "input", "valueArea", "historyCount"]

  start(event) {
    event.preventDefault()
    if (this.hasDisplayTarget) this.displayTarget.classList.add("hidden")
    if (this.hasFormTarget) this.formTarget.classList.remove("hidden")
    if (this.hasInputTarget) {
      this.inputTarget.focus()
      this.inputTarget.select()
    }
  }

  cancel(event) {
    event.preventDefault()
    if (this.hasDisplayTarget) this.displayTarget.classList.remove("hidden")
    if (this.hasFormTarget) this.formTarget.classList.add("hidden")
  }

  async submit(event) {
    event.preventDefault()
    const form = event.currentTarget
    const formData = new FormData(form)
    // NOTE: MA ( 複数選択 ) は value[] で配列、それ以外は value で 1 つの値が送られる
    const multi = formData.getAll("value[]").filter(v => v && v.length > 0)
    const newValue = multi.length > 0 ? multi.join(" / ") : (formData.get("value") || "")
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: {
          "Accept": "text/html",
          "X-CSRF-Token": csrfToken
        },
        body: formData
      })

      if (!response.ok) {
        console.error("書き換え保存に失敗しました", response.status)
        return
      }

      // display の値表示を新しい値で書き換え
      if (this.hasValueAreaTarget) {
        this.valueAreaTarget.textContent = newValue && newValue.length > 0 ? newValue : "未回答"
        this.valueAreaTarget.classList.toggle("text-gray-400", !newValue)
        this.valueAreaTarget.classList.toggle("italic", !newValue)
        this.valueAreaTarget.classList.toggle("text-gray-900", !!newValue)
      }
      // 履歴件数を +1
      if (this.hasHistoryCountTarget) {
        const m = this.historyCountTarget.textContent.match(/(\d+)/)
        const next = (m ? parseInt(m[1], 10) : 0) + 1
        this.historyCountTarget.textContent = `履歴 ${next} 件`
        this.historyCountTarget.classList.remove("hidden")
      }
      // form を hide、 display を show
      this.cancel(event)
    } catch (error) {
      console.error("書き換え保存に失敗しました", error)
    }
  }
}
